import { DataTable } from '@/components/common/DataTable';
import { Button } from '@/components/ui/button';
import { SuspiciousBet } from '@/types';
import { ColumnDef } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';

export default function SuspiciousBetsPage() {
  const navigate = useNavigate();

  const suspiciousBetColumns: ColumnDef<SuspiciousBet>[] = [
    { accessorKey: 'betId', header: 'Bet ID' },
    { accessorKey: 'playerId', header: 'Player ID' },
    { accessorKey: 'playerName', header: 'Player Name' },
    { accessorKey: 'roundId', header: 'Round ID' },
    { accessorKey: 'betType', header: 'Type' },

    {
      accessorKey: 'betAmount',
      header: 'Bet Amount',
      cell: ({ row }) => <span>₹{row.original.betAmount}</span>,
    },

    {
      accessorKey: 'payout',
      header: 'Payout',
      cell: ({ row }) => <span>₹{row.original.payout}</span>,
    },

    {
      accessorKey: 'reason',
      header: 'Reason',
      cell: ({ row }) => (
        <span className="text-yellow-400 font-semibold">{row.original.reason}</span>
      ),
    },

    {
      accessorKey: 'timestamp',
      header: 'Time',
      cell: ({ row }) => new Date(row.original.timestamp).toLocaleString('en-IN'),
    },

    {
      id: 'action',
      header: 'Actions',
      cell: ({ row }) => (
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate(`/players/profile/${row.original.playerId}`)}
        >
          View Player
        </Button>
      ),
    },
  ];

  const suspiciousBetData: SuspiciousBet[] = [
    {
      betId: 'BET90001',
      playerId: 'USR108',
      playerName: 'Karan Singh',
      roundId: 'RND12231',
      betType: 'Tiger',
      betAmount: 25000,
      payout: 0,
      reason: 'High Amount',
      timestamp: '2025-02-22T11:15:00Z',
    },
    {
      betId: 'BET90002',
      playerId: 'USR145',
      playerName: 'Ravi',
      roundId: 'RND12232',
      betType: 'Tie',
      betAmount: 500,
      payout: 10000,
      reason: 'Repeated Pattern',
      timestamp: '2025-02-22T11:20:00Z',
    },
  ];

  return (
    <>
      <div className="flex items-center justify-between mb-10">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">Suspicious Betting Activity</h2>
          <p className="text-muted-foreground">
            Automatically flagged betting patterns such as high-value bets, repeat-pattern bets, and
            unusual player behavior. Useful for fraud detection and risk assessment.
          </p>
        </div>
      </div>
      <DataTable
        columns={suspiciousBetColumns}
        data={suspiciousBetData}
        enableSearch
        enableFilters
        enableExport
        pageIndex={0}
        total={0}
        onPageChange={function (page: number): void {
          throw new Error('Function not implemented.');
        }}
        onPageSizeChange={function (size: number): void {
          throw new Error('Function not implemented.');
        }}
      />
    </>
  );
}
